import { render, staticRenderFns } from "./IconMarkRead.vue?vue&type=template&id=68c710d8&scoped=true"
import script from "./IconMarkRead.vue?vue&type=script&lang=js"
export * from "./IconMarkRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c710d8",
  null
  
)

export default component.exports